import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { AppContext, TOAST } from "../../context";
import RegisterTicketForm from "./Form";

const REGISTER_TICKET = gql`
  mutation registerTicket($payload: RegisterTicketMutation!) {
    registerTicket(payload: $payload) {
      isSuccess
      message
    }
  }
`;

const Register = () => {
  const { dispatch } = useContext(AppContext);
  const language = useSelector(state => state.language);
  const handleMutationError = error => {
    dispatch({ type: TOAST, payload: { text: error, variant: "error" } });
  };
  const handleMutationSuccess = ({ registerTicket }) => {
    if (registerTicket.isSuccess) {
      return dispatch({
        type: TOAST,
        payload: {
          text: language.Toasts.registerTicket,
          variant: "success"
        }
      });
    }
    return dispatch({
      type: TOAST,
      payload: {
        text: language.Toasts[registerTicket.message] || registerTicket.message,
        variant: "error"
      }
    });
  };
  const [registerTicket] = useMutation(REGISTER_TICKET, {
    onError: handleMutationError,
    onCompleted: handleMutationSuccess
  });

  const handleSubmit = (values, actions) => {
    registerTicket({ variables: { payload: values } }).then(() =>
      actions.resetForm()
    );
  };
  return (
    <div>
      <RegisterTicketForm
        handleSubmit={(values, actions) => handleSubmit(values, actions)}
        language={language}
      />
    </div>
  );
};

export default Register;
